import { QueryClient } from "@tanstack/react-query";

export function getNextPageParam(lastPage: {
  links: { next: null | string };
  meta: { current_page: number };
}) {
  if (lastPage?.links?.next) {
    return lastPage.meta.current_page + 1;
  }

  return undefined;
}

export function createQueryClient() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        gcTime: 60 * 1000,
        structuralSharing: false,
        refetchOnWindowFocus: false,
        retry: false,
        throwOnError: false,
      },
      mutations: {
        throwOnError: false,
      },
    },
  });

  return queryClient;
}
